import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { FileUploadComponent } from '../../common/file-upload/file-upload.component';

@Component({
  selector: 'app-impacted-generate',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    FormlyModule,
    ReactiveFormsModule,
    FormlyBootstrapModule,
    FileUploadComponent
  ],
  templateUrl: './impacted-generate.component.html',
  styleUrl: './impacted-generate.component.scss'
})
export class ImpactedGenerateComponent {

  @Input()
  title: string = '';

  @Input()
  fields: any = {};

  @Input()
  model: any = {};

  @Input()
  enableFileUpload = false;

  options: FormlyFormOptions = {};
  activeModal = inject(NgbActiveModal);
  form = new FormGroup({});

  fileUploadConfig = {
    fileUploadLabel: "Upload Test Cases",
    fileTypes: ".csv",
    buttonLabel: "Choose file",
    placeholderText: "CSV files only",
  };

  handleFilesSelected(event: any) {
    this.model.files = event?.files;
  }

  generate() {
    this.activeModal.close(this.model);
  }

}
